export const COMPONENTS_REDACTION = {
  digited: 'RedactionDigited',
  image: 'ImageRedaction',
};
